const legacyBrandPattern = /\bWONSIS\b/gi;
const replacementBrand = 'EASITENSION';
const blockedParents = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'OPTION']);
const replaceableAttributes = ['aria-label', 'title', 'placeholder', 'alt'];

function replaceBrand(value) {
  return value ? value.replace(legacyBrandPattern, replacementBrand) : value;
}

function replaceAttributes(element) {
  for (const attribute of replaceableAttributes) {
    if (!element.hasAttribute(attribute)) continue;
    const currentValue = element.getAttribute(attribute);
    const nextValue = replaceBrand(currentValue);
    if (nextValue !== currentValue) element.setAttribute(attribute, nextValue);
  }
}

function replaceVisibleBrand(root) {
  if (!(root instanceof Node)) return;

  if (root.nodeType === Node.TEXT_NODE) {
    if (!root.parentElement || blockedParents.has(root.parentElement.tagName)) return;
    const nextValue = replaceBrand(root.nodeValue);
    if (nextValue !== root.nodeValue) root.nodeValue = nextValue;
    return;
  }

  if (!(root instanceof Element || root instanceof Document || root instanceof DocumentFragment)) return;

  if (root instanceof Element) replaceAttributes(root);

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      if (node.nodeType === Node.ELEMENT_NODE && blockedParents.has(node.tagName)) {
        return NodeFilter.FILTER_REJECT;
      }
      return NodeFilter.FILTER_ACCEPT;
    },
  });

  let node = walker.nextNode();
  while (node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const nextValue = replaceBrand(node.nodeValue);
      if (nextValue !== node.nodeValue) node.nodeValue = nextValue;
    } else {
      replaceAttributes(node);
    }
    node = walker.nextNode();
  }
}

replaceVisibleBrand(document.body);
document.title = replaceBrand(document.title);

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.type === 'characterData') {
      replaceVisibleBrand(mutation.target);
      continue;
    }
    for (const node of mutation.addedNodes) replaceVisibleBrand(node);
  }
});

observer.observe(document.body, { childList: true, subtree: true, characterData: true });
